import {get} from 'common/utils/http';

const alertsRoot = 'api/v1/alerts/';

//* **alerts console
const fetchCurUserOpenAlertsCount = ({payload}) =>
  get(`${alertsRoot}triggered?size=0&startTime=${payload.startTime}&subscribers=${payload.userId}`);

export default fetchCurUserOpenAlertsCount;
